/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the Annex interface.
 */
export function instanceOfAnnex(value) {
    if (!('annexDate' in value) || value['annexDate'] === undefined)
        return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('annexNumber' in value) || value['annexNumber'] === undefined)
        return false;
    if (!('meteringPointsList' in value) || value['meteringPointsList'] === undefined)
        return false;
    return true;
}
export function AnnexFromJSON(json) {
    return AnnexFromJSONTyped(json, false);
}
export function AnnexFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'annexDate': (json['annex_date'] == null ? null : new Date(json['annex_date'])),
        'createdDate': (new Date(json['created_date'])),
        'status': json['status'],
        'type': json['type'],
        'annexNumber': json['annex_number'],
        'meteringPointsList': json['metering_points_list'] == null ? null : json['metering_points_list'],
    };
}
export function AnnexToJSON(json) {
    return AnnexToJSONTyped(json, false);
}
export function AnnexToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'annex_date': (value['annexDate'].toISOString().substring(0, 10)),
        'created_date': ((value['createdDate']).toISOString().substring(0, 10)),
        'status': value['status'],
        'type': value['type'],
        'annex_number': value['annexNumber'],
        'metering_points_list': value['meteringPointsList'],
    };
}
